import {AUTH} from 'src/shared/auth/actions';
import {token} from 'src/shared/auth/selectors';
import {phtTimeline} from 'src/shared/config/urls';
import {createFetchResourceAction} from 'src/shared/utils/resource';

export const READ_PHT_TIMELINE_START = 'READ_PHT_TIMELINE_START';
export const READ_PHT_TIMELINE_SUCCESS = 'READ_PHT_TIMELINE_SUCCESS';
export const READ_PHT_TIMELINE_ERROR = 'READ_PHT_TIMELINE_ERROR';
export const READ_PHT_TIMELINE_COMPLETE = 'READ_PHT_TIMELINE_COMPLETE';

export const readPhtTimeline = params => createFetchResourceAction({
  start: READ_PHT_TIMELINE_START,
  success: READ_PHT_TIMELINE_SUCCESS,
  error: READ_PHT_TIMELINE_ERROR,
  complete: READ_PHT_TIMELINE_COMPLETE,
  waitUntil: AUTH,
  url: state => phtTimeline(state, params),
  token,
});
